import { useQuery } from "@tanstack/react-query"

import { ContactResponses } from "@tfg/types/endpoints/contacts"

import { httpClient } from "~/backend/axios.ts"

export const useListSupplierContactsQuery = () => {
  return useQuery({
    queryKey: ["listContacts"],
    queryFn: async () =>
      (await httpClient.get<ContactResponses.Contact[]>("contacts")).data,
  })
}
